var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHostedEvent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "15px",
    viewBox: "0 0 12 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icHostedEvent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.91121127,8.30390559 C4.18870423,8.30390559 2.79805634,6.91984406 2.81385915,5.23695105 L2.81385915,3.28668252 C2.81385915,1.58806154 4.20450704,0.204 5.91121127,0.204 C7.61791549,0.204 9.00856338,1.58806154 9.00856338,3.28668252 L9.00856338,5.22122308 C9.00856338,6.91984406 7.61791549,8.30390559 5.91121127,8.30390559 Z M11.458,13.5413203 C11.458,13.7929678 11.2525634,13.9974315 11.0155211,13.9974315 L0.743690141,13.9974315 C0.49084507,13.9974315 0.285408451,13.7929678 0.285408451,13.5413203 L0.285408451,12.4875462 C0.285408451,11.6067797 0.727887324,10.8046531 1.48642254,10.332814 L3.65140845,8.99593636 C4.06228169,8.72856084 4.5363662,8.60273706 5.0104507,8.60273706 L6.66974648,8.60273706 C7.14383099,8.60273706 7.60211268,8.72856084 8.01298592,8.98020839 L10.2411831,10.332814 C10.9839155,10.7889252 11.458,11.6225077 11.458,12.5032741 L11.458,13.5413203 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "See-comments",
    transform: "translate(-16.000000, -347.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icHostedEvent",
    transform: "translate(15.720000, 347.360000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/black"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey",
    mask: "url(#mask-2)",
    fill: "#646464"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.720000, -1.360000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 17 0 17 17 0 17"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHostedEvent);
export default __webpack_public_path__ + "static/media/icHostedEvent.9f691d5cdd1597bad3f6b10980c1ea6c.svg";
export { ForwardRef as ReactComponent };